// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"Banner_alertContainer__2PQ44","alert":"Banner_alert__1jygd","closebtn":"Banner_closebtn__2HpZX","warningIcon":"Banner_warningIcon__rYSY3"};